import { Reveal } from "./Reveal";

const MOCKUPS = [
  { src: "/marketing/proof-gym.png",  alt: "proof — gym after work, proven" },
  { src: "/marketing/proof-run.png",  alt: "proof — 5K before work, proven" },
  { src: "/marketing/proof-cook.png", alt: "proof — cooked, not ordered, proven" },
  { src: "/marketing/proof-read.png", alt: "proof — 20 pages down, proven" },
];

export const Mockups = () => {
  return (
    <section
      id="mockups"
      className="relative overflow-hidden border-t border-[#1F1F1F] bg-[#050505] py-24 md:py-36"
    >
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[720px] -translate-x-1/2 rounded-full bg-[#C9A94B] opacity-[0.05] blur-[140px]" />

      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#C9A94B]">
              [ The app · up close ]
            </span>
            <h2 className="mt-4 font-display text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl">
              The receipts,<br />in your hand.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-xs font-body text-sm leading-relaxed text-[#8A8A8A]">
              Four real proofs from the feed. No filters. No streak inflation.
              Just receipts.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:gap-6 lg:grid-cols-4">
          {MOCKUPS.map((m, i) => (
            <Reveal key={m.src} delay={i * 0.08}>
              <figure className="mx-auto max-w-[320px]">
                <img
                  src={m.src}
                  alt={m.alt}
                  loading="lazy"
                  className="w-full transition-transform duration-500 hover:-translate-y-1"
                />
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
